module.exports = function getResource(label, vars = []) {
    const resources = {
        mobileModalTitle: 'Send Me Sephora Text Alerts',
        mobileModalSubtitle: 'You’re so close. A text is on the way!',
        sent: 'We sent it to you at',
        reply: 'Reply "Y" to confirm your subscription.',
        buttonContinue: 'Continue Shopping',
        mobileTerms: `By entering your phone number, clicking submit, and confirming sign-up, you consent to the [text terms|${vars[0]}] and to receive recurring autodialed marketing texts, including abandoned cart reminders. Message frequency varies. Consent is not a condition of purchase. Message & data rates may apply. See our [Privacy Policy|${vars[1]}].\n\nOpt-in to marketing text messages about Sephora-exclusive brand launches is available to Beauty Insiders only. If you have already opted-in to receive Sephora marketing text messages, you will receive updates about Sephora-exclusive brand launches and no further steps are necessary.`
    };

    return resources[label];
};
